import type { ComponentProps } from 'react'
import { tv } from '@joyful/utils'
import type { VariantProps } from '@joyful/utils'

export const splashVariants = tv({
  base: 'flex h-screen flex-col items-center justify-center gap-4 px-3',

  defaultVariants: {
    variant: 'gradient',
  },

  variants: {
    placement: {
      start: 'justify-start px-8 pt-24',
    },

    position: {
      relative: 'relative',
    },

    variant: {
      gradient:
        'bg-brand-gradient bg-cover bg-fixed bg-no-repeat dark:from-tremor-background dark:to-tremor-background-muted dark:bg-linear-to-br dark:via-yellow-900/20',
      plain: null,
    },
  },
})

export interface SplashProps
  extends
    Omit<ComponentProps<'main'>, 'className'>,
    VariantProps<typeof splashVariants> {}

export function Splash({
  children,
  placement,
  position,
  ref,
  variant,
  ...props
}: SplashProps) {
  return (
    <main
      ref={ref}
      className={splashVariants({
        placement,
        position,
        variant,
      })}
      {...props}
    >
      {children}
    </main>
  )
}
